import 'css-chunksrc/client/scenes/workloads/wbs/attachmentsCount/styles.scss';export default {
  "commentsCount": "_commentsCount_qsas2_1",
  "count": "_count_qsas2_8",
  "icon": "_icon_qsas2_14"
};